export default __webpack_public_path__ + "static/media/de_ad_banner.68965c2d.png";